module.exports = __webpack_public_path__ + "static/media/flag-us.5e17fd97.jpg";